import { NgModule } from '@angular/core';

import { DocumentsContainerComponent } from './documents.container';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { DocumentsEffects } from './documents.effects';
import { MobileCardComponent } from './mobile-card/mobile-card.component';
import { FieldModule } from 'atlas-field';
import { TabsModule } from 'atlas-tabs';
import { AccordionModule } from 'atlas-accordion';
import { AvatarModule } from 'atlas-avatar';
import { CardModule } from 'atlas-card';
import { ButtonModule } from 'atlas-button';
import { IconModule } from 'atlas-icon';
import { TableModule } from 'atlas-table';
import { PaginationModule } from 'atlas-pagination';

export const COMPONENTS = [
  DocumentsContainerComponent,
  MobileCardComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    // MercerOSModule,
    FormsModule,
    CommonModule,
    SharedModule,
    FieldModule,
    TabsModule,
    AccordionModule,
    AvatarModule,
    CardModule,
    ButtonModule,
    IconModule,
    TableModule,
    PaginationModule,
    EffectsModule.forFeature([DocumentsEffects])
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class DocumentsModule {
}
